import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { SAGE_ITEM_CODE_HELPER } from 'src/core/utils/sage-item-code';

@Component({
  selector: 'core-sage-item-code-field',
  templateUrl: './sage-item-code-field.component.html',
  styleUrls: ['./sage-item-code-field.component.scss'],
  standalone: false,
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class SageItemCodeFieldComponent {
  /** Numeric Sage item id from GET. Shown as text. Staff do not type it. */
  @Input() sageItemId: string | number | null = null;

  readonly helper = SAGE_ITEM_CODE_HELPER;

  get sageItemIdText(): string | null {
    if (this.sageItemId == null || String(this.sageItemId).trim() === '') return null;
    return String(this.sageItemId);
  }
}
